import { AllTypeActions } from "../types";
import { SigninInput, AlertSeverity, IUser } from "../interface";

export const postLogin = (input: SigninInput): any => {
  return {
    type: AllTypeActions.POST_LOGIN,
    input,
  };
};

export const getCurrentUser = (): any => {
  return {
    type: AllTypeActions.GET_CURRENT_USER,
  };
};

export const getListUser = (params?: {
  skip?: number;
  limit?: number;
  search?: string;
  role?: string;
  status?: string;
  classId?: string;
  groupId?: string;
}): any => {
  return {
    type: AllTypeActions.GET_LIST_USER,
    params,
  };
};

export const createUser = (input: Omit<IUser, "_id">): any => {
  return {
    type: AllTypeActions.CREATE_USER,
    input,
  };
};
export const updateUser = (input: IUser): any => {
  return {
    type: AllTypeActions.UPDATE_USER,
    input,
  };
};

export const deleteUser = (id: string): any => {
  return {
    type: AllTypeActions.DELETE_USER,
    id,
  };
};

export const showMessage = (message: string, severity?: AlertSeverity): any => {
  return {
    type: AllTypeActions.SYSTEM_MESSAGE_SHOW,
    message,
    severity,
  };
};

export const hideMessage = (): any => {
  return {
    type: AllTypeActions.SYSTEM_MESSAGE_HIDE,
  };
};
